import { render } from "./CateringPage.vue?vue&type=template&id=6efd970b"
import script from "./CateringPage.vue?vue&type=script&lang=js"
export * from "./CateringPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__